<template>
  <div
    v-if="status"
  >
    <!-- border-left-op${objetivo.orden} border-left-3 -->
    <b-card
      :class="`pl-1`"
      style="height: 24.5vh;"
    >
      <b-row>
        <b-col sm="6">
          <h2>
            <b-img
              style="width:11vh;height:11vh; margin-top: 1vh;"
              :src="require(`@/assets/images/prcp/op${objetivo.orden}.png`)"
            />
            <span style="padding-top: 4vh;"> OBJETIVO N° {{ objetivo.orden }} : <span :class="`colorop${objetivo.orden}`">
              {{ objetivo.descripcion }} </span></span> </h2>
          <b-col
            sm="12"
            style="padding-top: 1vh;"
          >
            <h4><strong>CONDUCTOR</strong> : {{ conductor.conductor.descripcion }}</h4>
            <!-- <h4><strong>RESPONSABLE</strong> : {{ conductor.conductor.responsable }}</h4>
            <h4><strong>TELÉFONO</strong> : {{ conductor.conductor.telefono }}</h4>
            <h4><strong>CORREO ELECTRÓNICO</strong> : {{ conductor.conductor.email }}</h4> -->
          <!-- <h4><strong>CONDUCTOR</strong> : {{ objetivo.representante }}</h4>
          <h4><strong>RESPONSABLE</strong> : PERSONA RESPONSABLE</h4>-->
          </b-col>
        </b-col>
        <b-col
          sm="3"
          class="mx-0"
          style="margin-top: 1vh;"
        >
          <h5>Avance de Objetivo</h5>
          <b-row
            class="text-center mx-0"
            style="width:5vh"
          >
            <!-- <div id="chart">
                    <div id="graficoAvance" />
                  </div> -->
            <vue-apex-charts
              type="radialBar"
              height="160"
              width="150"
              :options="chart.options"
              :series="chart.series"
            />
          </b-row>
        </b-col>
        <b-col
          sm="2"
          style="text-align: right;margin-top: 1vh;"
        >
          <h4>AÑOS</h4>
          <h6>FILTRO ACUMULADO</h6>
        </b-col>
        <b-col
          sm="1"
          style="text-align: right;;margin-top: 0.5vh"
        >
          <b-form-select
            v-model="selectedAnio"
            :options="optionsPeriodo"
            size="sm"
            @input="changeAnio"
          />
          <b-form-checkbox
            v-model="filterAcumulado"
            @input="changeFiltAcumulado"
          />
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <b-row class="font-small-2">
        <b-col sm="6">
          <h4>MEDIDAS DE POLÍTICA</h4>
        </b-col>
        <b-col
          sm="6"
          style="text-align: right;"
        >
          <b-avatar
            variant="danger"
            size="sm"
            text=" "
          /> 0%-30%
          <b-avatar
            size="sm"
            variant="warning"
            text=" "
          /> 30%-80%
          <b-avatar
            size="sm"
            variant="success"
            text=" "
          /> 80%-100%
        </b-col>
      </b-row>
    </b-card>
    <b-row sm="12">
      <b-col
        v-for="(medida,index) in medidas"
        :key="medida.medidaId"
        md="4"
        sm="4"
        class="mb-2"
        @click="medidaDetalle(medida.medidaId)"
      >
        <b-card class="align-items-center">
          <!-- <h3>MEDIDA {{ index+1 }}</h3>
            :style="`border: 4px solid #b8c2cc !important;border-radius: 16px;padding: 0.005em 2px 5px;`"
          -->
          <!-- <b-img
            style="width:80px;height:80px;"
            :src="require(`@/assets/images/prcp/op${index+1}.png`)"
          /> -->
          <b-row class="align-items-center">
            <b-col sm="12">
              <h5>
                <strong>CODIGO : {{ medida.codigo }} </strong>
              </h5>
            </b-col>

            <b-col sm="8">
              <h5>
                <strong>{{ medida.descripcion }} </strong>
              </h5>
            </b-col>
            <b-col sm="4">
              <vue-apex-charts
                type="radialBar"
                height="140"
                width="130"
                :options="chartData[index].options"
                :series="chartData[index].series"
              />
            </b-col>
            <b-col sm="6">
              Última actualización : {{ medida.fechaModificacion }}
            </b-col>
            <b-col
              sm="6"
              style="text-align: right;"
            >
              <div class="icon-wrapper">
                <feather-icon
                  v-b-tooltip.hover
                  :title="medida.detalle"
                  icon="InfoIcon"
                  size="50"
                />
              </div>
            </b-col>
          </b-row>
          <!-- <div class="progress-wrapper mb-2">
                <b-card-text class="mb-1 mt-1">
                  Avance de la medida {{ medida.avance+'%' }}
                </b-card-text>
                <b-progress
                  :value="`${medida.avance}`"
                  max="100"
                  class="progress-bar-secondary"
                  :variant="`success op${index+1}`"
                />
              </div>
              La información se actualiza diariamente. Última actualización: 15 de noviembre de 2021.
              -->

          <!-- <div
            :id="`graficoAvanceMedida${index}`"
            style="text-align: center;padding-top: 5px;"
          /> -->
        </b-card>
      </b-col>
    </b-row>
  </div>

</template>

<script>
import {
  BRow, BCol, BCard, BImg, BFormSelect, BAvatar, VBTooltip, BFormCheckbox,
} from 'bootstrap-vue'
import store from '@/store'
import router from '@/router'
//  import ApexCharts from 'apexcharts'
import { $themeColors } from '@themeConfig'
import Ripple from 'vue-ripple-directive'
import VueApexCharts from 'vue-apexcharts'
/* eslint-disable global-require */
const $trackBgColor = '#e9ecef'
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BImg,
    VueApexCharts,
    BFormSelect,
    BAvatar,
    BFormCheckbox,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      status: false,
      filterAcumulado: false,
      tipoFiltro: '1',
      objetivo: {},
      conductor: {},
      avance: 0.0,
      pendiente: 0,
      dataPie: [],
      serieAvance: [65],
      items: [],
      medidas: [],
      colorHito: '',
      chartColor: ['#8F5AA0', '#EABA18', '#63BCA6', '#5DB5E5', '#1D924C', '#E84462', '#6463A9', '#E96978', '#F08149'],
      chtClassReport1: null,
      modalShow: false,
      titleModal: 'Detalle',
      isBusyModal: false,
      typeAction: 'show',
      chartData: [],
      chartClone: {},
      chart: {
        series: [65],
        options: {
          stroke: {
            lineCap: 'round',
          },
          grid: {
            show: false,
            padding: {
              left: -15,
              right: -15,
              top: -12,
              bottom: -15,
            },
          },
          colors: [],
          plotOptions: {
            radialBar: {
              hollow: {
                size: '55%',
              },
              track: {
                background: $trackBgColor,
              },
              dataLabels: {
                name: {
                  show: false,
                },
                value: {
                  show: true,
                  offsetY: 3,
                  formatter(val) {
                    // eslint-disable-next-line radix
                    return `${(val).toFixed(1)}%`
                  },
                  fontSize: '1.5rem',
                  fontWeight: '600',
                },
              },
            },
          },
        },
      },
      selected: { value: '-1', text: 'TODOS' },
      selectedId: 0,
      selectedAnio: '-1',
      optionsPeriodo: [
      ],

    }
  },
  async mounted() {
    await this.listPeriodo()
    // await this.avanceObjetivo()
    // await this.avanceObjetivoMedida()
  },
  methods: {
    medidaDetalle(idMedida) {
      this.$router.push({ name: 'medida-detalle', params: { id: idMedida } })
    },
    changeAnio(data) {
      console.info(data)
      this.detalleObjetivo()
    },
    listObjetivoDetalle(periodoId) {
      const lastAnio = this.selected
      store.dispatch('gsseguimiento/ANIO_PERIODO_ALL', { periodo: periodoId, anio: this.selected })
        .then(response => {
          this.optionsPeriodo = []
          this.optionsPeriodo.push({ value: '-1', text: 'TODOS' })
          response.forEach(element => {
            this.optionsPeriodo.push({ value: element, text: element })
          })
          this.selected = lastAnio
        }).catch(error => {
          this.$bvToast.toast(error, {
            title: 'He ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    async detalleObjetivo() {
      this.status = false
      const idObejtivo = Number(router.currentRoute.params.id)
      this.medidas = []
      this.chartData = []
      await store.dispatch('gsseguimiento/REPORTE_OBJETIVO_DETALLE', {
        id: idObejtivo, periodo: this.selectedId, anio: this.selectedAnio, tipoFiltro: this.tipoFiltro,
      })
        .then(response => {
          this.avance = response.avance
          this.pendiente = response.pendiente
          this.objetivo = response.objetivo
          this.conductor = response.conductor
          this.medidas = response.medidas
          console.info('avance medida', response.avance)
          this.chart.series[0] = response.avance
          this.chart.options.colors[0] = this.chartColor[this.objetivo.orden - 1]
          this.avanceObjetivo()
          this.avanceObjetivoMedida()
          this.status = true
        }).catch(error => {
          this.$bvToast.toast(error, {
            title: 'He ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
      await this.listObjetivoDetalle(this.selectedId)
    },
    changeFiltAcumulado() {
      if (this.filterAcumulado) {
        this.tipoFiltro = '2'
        if (this.selectedAnio !== '-1') {
          this.detalleObjetivo()
        }
      } else {
        this.tipoFiltro = '1'
        this.detalleObjetivo()
      }
    },
    avanceObjetivo() {
      // if (this.chtClassReport1 !== null) {
      //   this.chtClassReport1.destroy()
      // }
      // const data = [
      //   { id: 1, total: 33, descripcion: 'Pendiente' },
      //   { id: 2, total: 67, descripcion: 'Avance' },
      // ]
      // const r1 = []
      // const r2 = []
      // data.forEach(dat => {
      //   r1.push(dat.total)
      //   r2.push(dat.descripcion)
      // })
      // this.chartOptionsReport1.series = r1
      // this.chartOptionsReport1.labels = r2
      // this.chartOptionsReport1.colors = ['#3B4659', '#1CC88A']
      // this.chtClassReport1 = new ApexCharts(document.querySelector('#graficoAvance'), this.chartOptionsReport1)
      // this.chtClassReport1.render()
    },
    avanceObjetivoMedida() {
      for (let i = 0; i < this.medidas.length; i += 1) {
        //   const data = [
        //     { id: 1, total: (100 - this.medidas[i].avance), descripcion: 'Pendiente' },
        //     { id: 2, total: this.medidas[i].avance, descripcion: 'Avance' },
        //   ]
        //   const r1 = []
        //   const r2 = []
        //   data.forEach(dat => {
        //     r1.push(dat.total)
        //     r2.push(dat.descripcion)
        //   })
        //   this.chartOptionsReport1.series = r1
        //   this.chartOptionsReport1.labels = r2
        //   // this.chartOptionsReport1.colors = ['#3B4659', '#1CC88A']
        //   this.chtClassReport1 = new ApexCharts(document.querySelector(`#graficoAvanceMedida${i}`), this.chartOptionsReport1)
        //   this.chtClassReport1.render()
        const chartClone = JSON.parse(JSON.stringify(this.chart))
        // const randow = Math.floor(Math.random() * (7 - 1 + 1)) + 1
        this.colorHito = $themeColors.danger
        if (this.medidas[i].avance > 30) { this.colorHito = $themeColors.warning }
        if (this.medidas[i].avance > 80) { this.colorHito = $themeColors.success }
        chartClone.options.colors[0] = this.colorHito
        chartClone.series[0] = this.medidas[i].avance
        this.chartData.push(chartClone)
      }
    },
    async listPeriodo() {
      store.dispatch('gsseguimiento/PERIODO_ALL_FIND', { periodo: -1 })
        .then(response => {
          //  { value: null, text: 'PERIODO' }
          // for (let i = 0; i < response.length; i += 1) {
          //   this.optionsPeriodo.push({ value: response[i].periodoId, text: response[i].descripcion })
          // }
          this.selected = response[response.length - 1].periodoId
          this.selectedId = response[response.length - 1].periodoId
          this.detalleObjetivo()
        }).catch(error => {
          this.$bvToast.toast(error, {
            title: 'He ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    onChangePeriodo(event) {
      this.selectedId = event
      this.detalleObjetivo()
    },
  },
}

// chartOptionsReport1: {
//         series: [],
//         chart: {
//           width: 230,
//           type: 'pie',
//           events: {},
//         },
//         labels: [],
//         responsive: [{
//           breakpoint: 200,
//           options: {
//             chart: {
//               width: 180,
//             },
//             legend: {
//               position: 'top',
//             },
//           },
//         }],
//         legend: {
//           show: true,
//           position: 'bottom',
//           horizontalAlign: 'center',
//           floating: false,
//           fontSize: '12px',
//           fontFamily: 'Helvetica, Arial',
//           fontWeight: 400,
//           formatter: undefined,
//           inverseOrder: false,
//           width: undefined,
//           height: undefined,
//           tooltipHoverFormatter: undefined,
//           customLegendItems: [],
//           offsetX: 0,
//           offsetY: 0,
//           labels: {
//             colors: undefined,
//             useSeriesColors: false,
//           },
//           markers: {
//             width: 12,
//             height: 12,
//             strokeWidth: 0,
//             strokeColor: '#fff',
//             fillColors: undefined,
//             radius: 15,
//             customHTML: undefined,
//             onClick: undefined,
//             offsetX: 12,
//             offsetY: 0,
//           },
//           itemMargin: {
//             horizontal: 7,
//             vertical: 0,
//           },
//           onItemClick: {
//             toggleDataSeries: true,
//           },
//           onItemHover: {
//             highlightDataSeries: true,
//           },
//         },
//         dataLabels: {
//           enabled: true,
//           enabledOnSeries: undefined,
//           textAnchor: 'middle',
//           distributed: false,
//           offsetX: 0,
//           offsetY: 0,
//           style: {
//             fontSize: '14px',
//             fontFamily: 'Helvetica, Arial, sans-serif',
//             fontWeight: 'bold',
//             colors: undefined,
//           },
//           background: {
//             enabled: true,
//             foreColor: '#fff',
//             padding: 4,
//             borderRadius: 2,
//             borderWidth: 1,
//             borderColor: '#fff',
//             opacity: 0.9,
//             dropShadow: {
//               enabled: false,
//               top: 2,
//               left: 5,
//               blur: 1,
//               color: '#000',
//               opacity: 0.45,
//             },
//           },
//           dropShadow: {
//             enabled: false,
//             top: 1,
//             left: 1,
//             blur: 1,
//             color: '#000',
//             opacity: 0.45,
//           },
//         },
//       },
</script>
<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';

.color-op1{
  color: #8F5AA0 !important;
}
.color-op2 {
  color: #EABA18 !important;
}
.color-op3 {
  color: #63BCA6 !important;
}
.color-op4 {
  color: #5DB5E5 !important;
}
.color-op5 {
  color: #1D924C !important;
}
.color-op6 {
  color: #E84462 !important;
}
.color-op7 {
  color: #6463A9 !important;
}
.color-op8 {
  color: #E96978 !important;
}
.color-op9 {
  color: #F08149 !important;
}

.border-left-op1 {
  border-color: 1px solid #8F5AA0;
}
.border-left-op2 {
   border-left: 1px solid #EABA18;
}
.border-left-op3 {
  border-left: 1px solid #63BCA6;
}
.border-left-op4 {
   border-left: 1px solid #5DB5E5;
}
.border-left-op5 {
   border-left: 1px solid #1D924C;
}
.border-left-op6 {
   border-left: 1px solid #E84462;
}
.border-left-op7 {
   border-left: 1px solid #6463A9;
}
.border-left-op8 {
   border-left: 1px solid #E96978;
}
.border-left-op9 {
   border-left: 1px solid #F08149;
}

.centrate{
  text-align: center;
}
.card-body{
      padding: 1.3rem;
}
.colorop1{
  color: #8F5AA0 !important;
}
.colorop2 {
  color: #EABA18 !important;
}
.colorop3 {
  color: #63BCA6 !important;
}
.colorop4 {
  color: #5DB5E5 !important;
}
.colorop5 {
  color: #1D924C !important;
}
.op6 {
  color: #E84462 !important;
}
.colorop7 {
  color: #6463A9 !important;
}
.colorop8 {
  color: #E96978 !important;
}
.colorop9 {
  color: #F08149 !important;
}
.card-body {
    padding: 0.9rem;
}
</style>
